















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { required } from 'vuelidate/lib/validators'
import { date } from 'quasar'
import { TranslateResult } from 'vue-i18n'

/**
 * isValidTime is a utility function that check if the time is valid or not.
 * Regex pattern used checks if the time value is in the format of 00:00
 *
 * @param time							- String in format of `00:00`
 */
const isValidTime = (time: string): boolean => {
	const timePattern: RegExp = /^([0-1]?\d|2[0-3]):[0-5]\d$/
	return timePattern.test(time)
}

const timeFitsPrevTime = (time: string, data: any): boolean => {
	const { prevTime, destinationTime, isTooShort } = data
	const destinationDate: Date = date.addToDate(new Date(Date.now()), { year: 1 })
	const needToComparePreviousTime: boolean = (prevTime && typeof destinationTime === 'undefined')

	if (needToComparePreviousTime || isTooShort) {
		return date.isBetweenDates(`2020-01-01T${time}:00`, `2020-01-01T${prevTime}:00`, destinationDate)
	} else {
		return true
	}
}

const timeFitsDestinationTime = (time: string, data: any): boolean => {
	if (data.destinationTime && data.destinationTime.length === 5) {
		return date.isBetweenDates(`2020-01-02T${time}:00`, `2020-01-01T23:59:00`, `2020-01-02T${data.destinationTime}:00`)
	} else {
		return true
	}
}

@Component({
	name: 'Timepicker',
	validations: {
		modelData: {
			required,
			isValidTime,
			timeFitsPrevTime,
			timeFitsDestinationTime
		}
	}
})
export default class Timepicker extends Vue {
	@Prop()
	private time!: string
	@Prop({ default: undefined })
	private prevTime!: string | undefined
	@Prop({ default: undefined })
	private destinationTime!: string | undefined
	@Prop({ default: false })
	private isTooShort!: boolean
	private modelData: string = this.time

	private get getPrevTimeText (): string | TranslateResult {
		return this.isTooShort ? this.$t('errors.fields.timeRangeIsTooLow') : this.$t('errors.fields.outOfChronology')
	}

	private onTimePickerInput (date: string): void {
		this.$emit('field-updated', date)
	}
}
